import { george } from "aaa";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import * as React from "react";
import { FormattedHTMLMessage } from "react-intl";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { amountToCurrencyString, amountToNumber } from "types/amount";
import { GeorgeIdBanner } from "../components/GeorgeIdBanner";
import { SectionHeader } from "../components/SectionHeader";
import { Settings } from "../components/Settings";
import { SigningMethodBanner } from "../components/SigningMethodBanner";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";
import { CardTanSettingsStore } from "./CardTanSettingsStore";
import { pushRoute } from "stores/RouterFunctions";

export const CardTanSettingsHomeScreen = observer(({ store }: { store: CardTanSettingsStore }) => {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleClickGeorgeIdBanner = async () => {
        try {
            await store.activateGeorgeId();
            pushRoute(CardTanSettingsRoutes.ACTIVATE_GEORGE_ID_SIGNING);
        } catch (error) {
            pushRoute("/error");
        }
    };

    if (store.isLoading) {
        return (
            <george.LoadingIndicator isLoading height={ui.windowHeight} />
        );
    }

    let limit = ui.__("sidentity.limit.none");
    if (store.cardTanLimit
        && store.cardTanLimit.dailyLimit
        && amountToNumber(store.cardTanLimit.dailyLimit) > 0
    ) {
        limit = amountToCurrencyString(store.cardTanLimit.dailyLimit);
    }

    return (
        <george.Background style={{ padding: 16 }}>
            {/* {externalInterfaceStore.isGeorgeApp && (
                <GeorgeIdBanner onClick={handleClickGeorgeIdBanner} style={{ marginTop: 16, marginBottom: 32 }} />
            )} */}
            <SectionHeader>{ui.__("cardTanSettings.signingMethod")}</SectionHeader>
            <SigningMethodBanner>
                <FormattedHTMLMessage id="cardTanSettings.signingMethod.cardTan" />
            </SigningMethodBanner>
            <Settings store={store.aliasStore} limit={limit} limitManagementRoute={CardTanSettingsRoutes.LIMIT} showLimit style={{ marginTop: 16 }} />
        </george.Background>
    );
});


// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsHomeScreen.tsx